/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { getApiPath } from "../utils";

interface PriceQueryProps {
	country: string;
	namespace: string;
	lineOffers: { offerId: string }[];
	identityId?: string;
	locale: string;
}

export interface PriceRes {
	discountPrice?: number;
	originalPrice?: number;
	originalPriceStr?: string;
	discountPriceStr?: string;
	isSale: boolean;
	isFree: boolean;
	hasPrice: boolean;
	currencyCode?: string;
	fetched: boolean;
	currencyInfo: {
		code: string;
		decimals: number;
	};
}

export const getPrice = async (variables: PriceQueryProps): Promise<PriceRes> => {
	try {
		console.log("PriceFetch.getPrice() fetching...", variables);
		const response = await fetch(`${getApiPath()}/price`, {
			method: "POST",
			credentials: "include",
			body: JSON.stringify(variables),
		});
		const price = await response.json();

		const totalPrice = price.totalPrice || {};
		const currencyCode = totalPrice.currencyCode;
		const fmtPrice = totalPrice.fmtPrice || {};
		const originalPriceStr = fmtPrice.originalPrice;
		const discountPriceStr = fmtPrice.discountPrice;

		const hasPrice = Boolean(originalPriceStr && originalPriceStr.length);

		const isSale = Boolean(
			hasPrice && discountPriceStr && discountPriceStr.length && originalPriceStr !== discountPriceStr,
		);

		const isFree: boolean = !hasPrice || totalPrice.originalPrice === 0;

		console.log("PriceFetch.getPrice() success", totalPrice);

		return {
			originalPrice: totalPrice.originalPrice,
			discountPrice: totalPrice.discountPrice,
			originalPriceStr,
			discountPriceStr,
			isSale,
			isFree,
			hasPrice,
			currencyCode,
			fetched: true,
			currencyInfo: totalPrice?.currencyInfo || {},
		};
	} catch (err) {
		console.error("getPrice() failed to load");
		throw err;
	}
};
